export const tooltipTheme = {
  baseStyle: {
    // Dark mode: a raised grey with light text (GitHub's dark tooltip), not
    // the inversion `secondary-950`/`white` would give, a white box. The
    // `--kula-dark-*` aliases exist only in dark, so light mode is unchanged.
    bg: 'var(--kula-dark-secondary-200, #262244)',
    p: '6px 8px',
    color: 'var(--kula-dark-secondary-950, #FFFFFF)',
    // Tooltip labels are written for the dark light-mode tooltip with
    // `color="white"`, which dark mode turns into the dark surface (dark text
    // on the grey tooltip). Inside a tooltip, `white` means the tooltip text.
    '--kula-colors-white': 'var(--kula-dark-secondary-950, #FFFFFF)',
    borderRadius: '6px',
    zIndex: '999999',
    '[data-popper-arrow]': {
      display: 'none',
    },
  },
  variants: {
    default: {},
  },
  defaultProps: {
    variant: 'default',
  },
};
